var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9 3.665 12.333 7m-7.696 7.239-2.508.418a.683.683 0 0 1-.786-.786l.418-2.508c.07-.421.27-.81.572-1.112l8.317-8.318c.8-.8 2.098-.8 2.899 0l.517.518c.8.8.8 2.098 0 2.898L5.75 13.666a2.05 2.05 0 0 1-1.112.572"
  })));
};
export default SvgEdit;